// extracted by mini-css-extract-plugin
export default {"main":"Main_main__qG0SZ","title_big":"Main_title_big__pDumC","flareAnimation":"Main_flareAnimation__SmEB8","shine":"Main_shine__llNT-"};